import React, { useEffect, useState } from "react";
import styles from "./includeElements.module.css";
import ModalHeader from "common/ModalHeader";
import Button from "common/Button";
import { getAll } from "utils/queries";
import { formatDateFromDateAndTime, groupedData } from "utils";
import CheckBox from "common/CheckBox";

const IncludeElements = ({ packageDetails, syncState }) => {
  // Track if we've already loaded data to prevent multiple initializations
  const [hasInitialized, setHasInitialized] = useState(false);

  const mapElements = (data) => {
    const groupedVariants = groupedData(data);
    console.log(groupedVariants, "ceccrvrfv");

    // const groupedVariants = data;
    syncState({ ...packageDetails, elements: groupedVariants });
  };

  const fetchAllTicketsVariants = async () => {
    try {
      // Only fetch if we haven't initialized yet
      if (hasInitialized) return;

      const result = await getAll(`ticket/ticketVariants/all`);
      const data = result?.data?.data?.rows;

      if (!data) {
        console.error("No data received from API");
        return;
      }

      let updatedData;
      if (packageDetails?.elements && packageDetails.elements.length > 0) {
        // Create a map of variant IDs to checked status for quick lookup
        const variantCheckedMap = {};
        packageDetails.elements.forEach((ticket) => {
          ticket.variants?.forEach((variant) => {
            if (variant.variant_id) {
              variantCheckedMap[variant.variant_id] = variant.checked;
            }
          });
        });

        updatedData = data.map((ticket) => ({
          ...ticket,
          variants:
            ticket.variants?.map((variant) => ({
              ...variant,
              // Preserve the existing checked state if it exists, otherwise false
              checked: variantCheckedMap[variant.variant_id] || false,
            })) || [],
        }));
      } else {
        updatedData = data.map((ticket) => ({
          ...ticket,
          variants:
            ticket.variants?.map((variant) => ({
              ...variant,
              checked: false,
            })) || [],
        }));
      }

      mapElements(updatedData);
      setHasInitialized(true);
    } catch (error) {
      console.error("Error fetching ticket variants:", error);
    }
  };

  useEffect(() => {
    fetchAllTicketsVariants();
  }, []);

  const handleTicketChecks = (ticketId, variantId) => {
    if (!packageDetails?.elements) return;

    const updatedElements = packageDetails.elements.map((element) => {
      if (element.id === ticketId) {
        return {
          ...element,
          variants: element.variants.map((variant) => ({
            ...variant,
            checked:
              variant.variant_id === variantId
                ? !variant.checked
                : variant.checked,
          })),
        };
      }
      return element;
    });

    syncState({ ...packageDetails, elements: updatedElements });
  };

  const handlePackageElements = (e) => {
    e.preventDefault();
  };

  return (
    <div className={styles.bookingJourney}>
      <ModalHeader label="Included elements" />
      <form onSubmit={handlePackageElements}>
        <div className={styles.body}>
          {packageDetails?.elements?.flatMap((value) =>
            value.variants && value.variants.length > 0
              ? value.variants.map((variant) => (
                  <React.Fragment key={`${value.id}-${variant.variant_id}`}>
                    <div className={styles.elements}>
                      <img
                        src={value.image_url}
                        className={styles.elementsImg}
                        alt={value.ticket_name}
                      />
                      <div className={styles.elementBody}>
                        <div className={styles.name}>
                          {/* {variant.variant_name || value.ticket_name} */}
                          {value.ticket_name}
                        </div>
                        <div className={styles.name}>
                          {value.element_description}
                        </div>
                      </div>
                    </div>
                    <div className={styles.addOns}>
                      <div className={styles.addOnsLabel}>Select Tickets</div>
                      <div>
                        <CheckBox
                          key={variant.variant_id}
                          label={variant.variant_name || value.ticket_name}
                          checked={variant.checked || false}
                          onClick={() =>
                            handleTicketChecks(value.id, variant.variant_id)
                          }
                        />
                      </div>
                    </div>
                  </React.Fragment>
                ))
              : []
          )}
        </div>
      </form>
    </div>
  );
};

export default IncludeElements;
